import React from 'react'
import Styles from './CourseEnrolled.module.scss'
import { useAPI, useNavigate } from 'components/lib'
import { CoursesCard } from 'components/CoursesCard/CoursesCard';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import { useState } from 'react';
import { useEffect } from 'react';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { BreadCrumbs } from 'components/global/BreadCrumbs/BreadCrumbs';

export function CourseEnrolled() {
    const { data, loading } = useAPI('/api/lms/user/courses/enrolled')

    const [courses, setCourses] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        if (data) {
            setCourses(data);
        }
    }, [data])

    return (
        <>
            <LoadingBackdrop
                isOpen={loading}
            />
            {data && (
                <div className={Styles.ancestorContainer}>
                    <span className={Styles.enrollAndHeading}>
                        <p
                            className={Styles.pageTitle}
                        >
                            My Courses
                        </p>
                        <button onClick={() => { navigate('/lms/courses/all') }} className={Styles.enrollPage}><AddCircleOutlineIcon /> Enroll</button>
                    </span>
                    <span className={Styles.BreadCrumbsContainer}>
                        <BreadCrumbs onClickPaths={['/lms/courses/all', '']} crumbs={['Available Courses', 'Enrolled Courses']} />
                    </span>
                    <div className={Styles.mainContainer}>

                        <div className={Styles.coursesContainer}>
                            {
                                courses?.length > 0 ?
                                    courses?.map((course, index) => (
                                        <CoursesCard
                                            key={`${course.id}`}
                                            data={course}
                                            onClick={() => { navigate(`/lms/courses/${course?.id}/modules`) }}
                                        />
                                    )) :
                                    <p>No Courses Found</p>
                            }
                        </div>
                        {/* <div className={Styles.paginationContainer}>
                        <Pagination
                            // size='small'
                            siblingCount={0}
                            count={totalPages}
                            color="primary"
                            variant='outlined'
                            onChange={handlePageChange}
                        />

                    </div> */}
                    </div>
                </div>
            )}
        </>

    )
}
